// Load Styles
import '../scss/main-tptf.scss';

// Load Bootstrap init
import { initBootstrap } from "./bootstrap.js";
import $ from 'jquery'
import 'slick-carousel'
import '../scss/tptf/js/lightbox.js';
import '../scss/tptf/js/site.js';
import '../scss/tptf/js/cookies.js';
import '../scss/tptf/js/rating.js';

//import './utilities/CrolowForms.js';
import { Tooltip, Toast, Popover } from 'bootstrap';

// Your app code
console.log(`Hello ${process.env.HELLO}`);
